module.exports = __webpack_public_path__ + "static/media/Product-Box.e07d4761.png";